import React, { useEffect } from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { useLanguage } from '../LanguageContext';
import translations from '../translations';
import { Link as RouterLink } from 'react-router-dom';

const News = () => {
    const { language = 'en' } = useLanguage() || {};
    
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: '#000000', // Black background
        color: '#ffffff',   // White text
        pt: { xs: 8, sm: 10, md: 12, lg: 14 },
        pb: { xs: 8, sm: 10, md: 12, lg: 14 },
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h1"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
              mb: 4
            }}
          >
            {translations[language] && translations[language]['News'] ? translations[language]['News'] : 'News'}
          </Typography>
          
          <Box 
            sx={{
              width: { xs: '100%', md: '70%' },
              mx: 'auto',
              mb: 8,
              mt: { xs: 4, md: 8 }
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 'normal',
                fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                lineHeight: 1.5,
                mb: 4
              }}
            >
              {translations[language] && translations[language]['NewsNoContent'] 
                ? translations[language]['NewsNoContent'] 
                : 'Non ci sono notizie al momento. Per rimanere aggiornato sulle iniziativi di CRH Money, iscriviti alla nostra newsletter.'}
            </Typography>
            
            <Box
              sx={{
                mt: 10,
                width: '100%',
                height: '2px',
                bgcolor: 'rgba(255,255,255,0.1)',
              }}
            />
            
            <Typography
              variant="body1"
              sx={{
                mt: 10,
                fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                fontStyle: 'italic',
                opacity: 0.8
              }}
            >
              {translations[language] && translations[language]['NewsSubscribeText'] 
                ? translations[language]['NewsSubscribeText'] 
                : 'Publicheremo le notizie e gli eventi del mondo esclusivo di CRH Money al piu presto.'}
            </Typography>
            
            <Button
              component={RouterLink}
              to="/"
              variant="outlined"
              sx={{
                mt: 8,
                color: '#ffffff',
                borderColor: '#ffffff',
                borderWidth: '1px',
                borderRadius: '4px',
                padding: '10px 20px',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: '#ffffff'
                }
              }}
            >
              {translations[language] && translations[language]['ReturnToHome'] 
                ? translations[language]['ReturnToHome'] 
                : 'Torna alla Home'}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
  };
  

export default News;